module.exports = __webpack_public_path__ + "static/media/IMG_7300-min.63d54aeb.JPG";